
import { Vue, Component, Prop, Ref, Inject } from 'vue-property-decorator';
import BaseCard from "@/components/base/BaseCard.vue";
import EmployeeMethodAboutItem from "@/components/administration/employeesMethods/EmployeeMethodAboutItem.vue";
import { EmployeeMethod, IAboutItem, IEditableAboutItem } from "@/services/administration/EmployeeMethod";

@Component({
    components: { EmployeeMethodAboutItem, BaseCard },
})
export default class EmployeeMethodAbout extends Vue {
    @Prop({ required: true }) employeeMethod!: EmployeeMethod;
    @Ref() aboutItems!: EmployeeMethodAboutItem[];
    @Inject() readonly getEmployeeMethod!: any;

    isEdit: boolean = false;
    dataToSend = {};

    get getItems(): IAboutItem[] | IEditableAboutItem[] {
        return this.isEdit ? this.employeeMethod.getAboutItemsForEdit : this.employeeMethod.getAboutItems;
    }

    async editMode(isEdit: boolean): Promise<void> {
        if (isEdit) {

        } else {
            this.dataToSend = Object.fromEntries(this.aboutItems.map(item => [item.item.id, item.value]));
            await this.employeeMethod.updateEmployeeMethod(this.dataToSend);
            await this.getEmployeeMethod();
        }
        this.isEdit = isEdit;
    }

}
